import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=4146754d&scoped=true"
import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"
import style0 from "./folder.vue?vue&type=style&index=0&id=4146754d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146754d",
  null
  
)

export default component.exports